import { createSelector } from 'reselect'

export const getAlgolia = (state: Record<string, any>): Record<string, any> => state.algolia || {}

export const getSelectedFacets = createSelector(
  getAlgolia,
  (pageData): Record<string, any> => {
    return pageData.selectedFacets || {}
  }
)
export const getSelectedFacetsSizeMinMax = createSelector(
  [getSelectedFacets],
  (selectedFacets): Record<string, any> => {
    const [widthMin, widthMax] = (selectedFacets.width || '').split('-')
    const [heightMin, heightMax] = (selectedFacets.height || '').split('-')
    return {
      widthMin: widthMax ? Number(widthMin || '') : '',
      widthMax: Number(widthMax || ''),
      heightMin: heightMax ? Number(heightMin || '') : '',
      heightMax: Number(heightMax || ''),
    }
  }
)
